import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          header: {
            contact_us: "Contact Us",
            about_us: "About Us",
            prototype: "Prototype",
            autonomous_robot: "Autonomous Robot",
          },
          hero : {
            title: "Invest in the Future of Food Delivery with Our Innovative Robot",
            description: "Join us in our mission to transform the industry and make food delivery better for everyone. Invest in our robot today and be a part of the food delivery revolution!",
            button_text: "Robot's Prototype",
          },
          products: {
            title: "Robot's Prototype",
          },
          about_the_robot: {
            title: "What Make Us The Best",
            subtitle: "robot's features",
            safety : "Safety & navigation",
            safety_description : "The robots are incredibly intelligent, with a suite of sensors, along with 12 cameras to enable each one to see where it’s going. The technology enables them to navigate around objects and people they may come across.",
            battery : "Battery-powered",
            battery_description : "Batteries provide an energy-efficient and environmentally-friendly solution to last mile delivery. Each charge lasts a full day of deliveries before needing to be recharged.",
            secure : "Secure delivery",
            secure_description : "Each robot is GPS tracked to the nearest inch, whilst the lid is also locked throughout the delivery journey, protecting the items inside.",
            capacity : "Capacity",
            capacity_description : "The robots are deceptively large and can carry up to three bags of groceries.",
          },
          cta: {
            title: "Contact Us to Invest in Our Robot",
            subtitle: "BE A PART OF THIS REVOLUTION!",
            who_we_are: "Who we are!",
            description: "As university students, we have developed a ptototype of an investor-ready food delivery robot that is set to revolutionize the industry. Our robot combines cutting-edge technology with a user-friendly interface, providing a seamless food delivery experience. We are seeking investors who share our vision and are excited about the potential of our robot to change the industry. Contact us today to learn more about our project and how you can get involved.",
            email_label: "Email",
            email_placeholder: "username@gmail.com",
            subject_label: "Subject",
            subject_placeholder: "Ready to set a meeting",
            description_label: "Description",
            description_placeholder: "We are excited to meet and get more informations.....",
            button_text: "Send",
          },
          footer: {
            copyright: "All rights reserved.",
            startup: "Startup",
            about_us: "About Us",
            prototype: "Prototype",
            contact: "Contact",
          },
        }
      },
      tr: {
        translation: {
          header: {
            contact_us: "İletişim",
            about_us: "Hakkımızda",
            prototype: "Prototip",
            autonomous_robot: "Otonom Robotumuz",
          },
          hero : {
            title: "Yenilikçi Robotumuzla geleceğin Yemek teslimatına yatırım Yapın!",
            description: "Siz de yemek teslimatını daha iyi hale getirmek için teslimat sektörünü dönüştürme macerasına katılın. Robotumuza bugün yatırım yapın ve yemek teslimatı devriminin bir parçası olun!",
            button_text: "Robot Prototipi",
          },
          products: {
            title: "Robot Prototipi",
          },
          about_the_robot: {
            title: "Bizi En İyi Yapan Özellikler",
            subtitle: "Robotun ÖZELLİKLERİ",
            safety : "Güvenlik ve Navigasyon",
            safety_description : "Her robotumuzun nereye gittiğini görmesine olanak sağlayan 12 kameranın yanı sıra bir dizi sensöre sahiptir. Kullandığımız teknoloji, karşılaşabilecekleri nesneler ve insanlar etrafında gezinmelerine izin verir.",
            battery : "Pil ile Çalışır",
            battery_description : "Piller son kilometre teslimatı için enerji verimli ve çevre dostu bir çözüm sunar. Her şarj, şarj edilmesi gerektiği zaman önceki gün boyunca teslimatlar için yeterli enerji sağlar.",
            secure : "Güvenli Teslimat",
            secure_description : "Robot kapağı teslimat süreci boyunca kilitli kalır ve içindeki öğeleri korur.",
            capacity : "Kapasite",
            capacity_description : "Robotlar yeterli derecede büyük ve üç çanta dolusu yiyeceği taşıyabilir.",
          },
          cta: {
            title: "Hemen bizimle iletişime geçin",
            subtitle: "Bu DEVRİMİN BİR parçası olun!",
            who_we_are: "Biz Kimiz!",
            description: "Üniversite öğrencileri olarak, teslimat sektörünü devrimleştirecek yatırımcıya hazır bir teslimat robotu prototipi geliştirdik. Robotumuz, son teknoloji ile kullanıcı dostu bir arayüzü birleştirilerek sorunsuz bir teslimat deneyimi sağlıyor. Vizyonumuzu paylaşan ve robotumuzun sektörü geliştirme potansiyeline sahip olan yatırımcıları arıyoruz. Projemiz hakkında daha fazla bilgi edinmek ve nasıl dahil olabileceğinizi öğrenmek için bugün bizimle iletişime geçin.",
            email_label: "Eposta",
            email_placeholder: "kullanıcı@gmail.com",
            subject_label: "Konu",
            subject_placeholder: "konuyla ilgili bilgi edinmek istiyoruz",
            description_label: "Açıklama",
            description_placeholder: "sizinle bir araya gelmek için toplantı yapalım.....",
            button_text: "Gönder",
          },
          footer: {
            copyright: "Tüm hakları saklıdır.",
            startup: "Startup",
            about_us: "Hakkımızda",
            prototype: "Prototip",
            contact: "İletişim",
          },
        }
      },
    }
  });

export default i18n;